// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RFowxc{display:flex;align-items:center;gap:18px;padding:0 30px;height:48px;background:none;border:none;border-bottom:1px solid rgba(255,255,255,0.3);width:100%;cursor:pointer}.iDB1xc{font-weight:bold;font-size:14px;color:white}.OWpiRx{list-style:none;margin:0;padding:12px 0}button.zDqeSi{padding:0 30px;height:36px;border:none;background:none;width:100%;margin:0;color:white;text-align:left;font-size:14px;cursor:pointer;transition:background .1s;display:grid;align-items:center;grid-template-columns:30px 1fr}button.zDqeSi:hover{background:rgba(100,100,100,0.7)}.T5L_EU{grid-column-start:2;font-size:14px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backButton": `RFowxc`,
	"title": `iDB1xc`,
	"list": `OWpiRx`,
	"optionButton": `zDqeSi`,
	"optionTitle": `T5L_EU`
};
export default ___CSS_LOADER_EXPORT___;
